import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthRequire } from "../contexts/Auth/AuthRequire";
import {
  AuthScreen,
  BaixaReserva,
  CancelarReserva,
  DescancelarReserva,
  Employees,
  Home,
  Login,
  MyReservations,
  Partners,
  Passageiros,
  ReservasEfetuadas,
  Reservation,
  Tours,
} from "../pages";
import { ResetPassword } from "../pages/AuthScreen/ResetPassword";
import { Details } from "../pages/Operational/MyReservations/Details";
import { Recibo } from "../pages/Recibo";
import { FormDireitos } from "../pages/Records/Employees/FormDireitos";
import { FormEmployee } from "../pages/Records/Employees/FormEmployee";
import { FormEmployeeEdit } from "../pages/Records/Employees/FormEmployeeEdit";
import { FormPartner } from "../pages/Records/Partners/FormPartner";
import { FormPartnerEdit } from "../pages/Records/Partners/FormPartnerEdit";
import { FormTour } from "../pages/Records/Tours/FormTour";
import { FormTourEdit } from "../pages/Records/Tours/FormTourEdit";
import { Checkin } from "../pages/Reporter/Checkin";
import { Embarque } from "../pages/Reporter/Embarque";
import { Faturamento } from "../pages/Reporter/Faturamento";
import { Gerencial } from "../pages/Reporter/Gerencial";
import { Reservas } from "../pages/Reporter/Reservas";

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="auth/:screen" element={<AuthScreen />} />
        <Route path="auth/login" element={<Login />} />
        <Route path="auth/login/:baixareserva" element={<Login />} />
        <Route path="recibo" element={<Recibo />} />

        <Route
          path="/"
          element={
            <AuthRequire>
              <Home />
            </AuthRequire>
          }
        >
          <Route path="cadastros/funcionarios" element={<Employees />} />
          <Route path="cadastros/funcionarios/new" element={<FormEmployee />} />
          <Route
            path="cadastros/funcionarios/:funcionarioID"
            element={<FormEmployeeEdit />}
          />
          <Route
            path="cadastros/funcionarios/direitos/:funcionarioID"
            element={<FormDireitos />}
          />
          <Route path="cadastros/parceiros" element={<Partners />} />
          <Route path="cadastros/parceiros/new" element={<FormPartner />} />
          <Route
            path="cadastros/parceiros/:parceiroID"
            element={<FormPartnerEdit />}
          />
          <Route path="cadastros/passeios" element={<Tours />} />
          <Route path="cadastros/passeios/new" element={<FormTour />} />
          <Route
            path="cadastros/passeios/:passeioID"
            element={<FormTourEdit />}
          />

          <Route path="auth/alterar-senha" element={<ResetPassword />} />

          <Route path="operacional/baixareserva" element={<BaixaReserva />} />
          <Route
            path="operacional/cancelarreserva"
            element={<CancelarReserva />}
          />
          <Route
            path="operacional/descancelarreserva"
            element={<DescancelarReserva />}
          />
          <Route path="operacional/reservas" element={<Reservation />} />
          <Route path="operacional/relreservas" element={<MyReservations />} />
          <Route
            path="operacional/reservasefetuadas"
            element={<ReservasEfetuadas />}
          />
          <Route
            path="operacional/passageiros/:reservationID"
            element={<Passageiros />}
          />
          <Route
            path="operacional/relreservas/:reservationID"
            element={<Details />}
          />

          <Route path="relatorios/checkin" element={<Checkin />} />
          <Route path="relatorios/embarque" element={<Embarque />} />
          <Route path="relatorios/faturamento" element={<Faturamento />} />
          <Route path="relatorios/reservas" element={<Reservas />} />
          <Route path="relatorios/gerencial" element={<Gerencial />} />
        </Route>

        <Route path="*" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}
